module.exports = __webpack_public_path__ + "static/img/harrison-zane.680fc7e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/harrison-zane.jpg
// module id = uier
// module chunks = 0